<template>
  <div class="wl-monitor-count-widget">
    <div class="wl-monitor-count-widget__inner">
      <div class="wl-monitor-count-widget__content">
        <div class="wl-monitor-count-widget__header">
          <h2 class="wl-monitor-count-widget__title">
            Monitored Reports
          </h2>
          <span class="wl-monitor-count-widget__count">
            {{ reportsMonitored }}/{{ limit }}
          </span>
        </div>
        <div class="wl-monitor-count-widget__progress">
          <div
            class="wl-monitor-count-widget__progress-bar"
            :style="{ width: progressPercentage }"
          />
        </div>
        <p class="wl-monitor-count-widget__slots">
          {{ slotsRemainingText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'WlMonitorCountWidget',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('report-monitor', ['reportsMonitored', 'limit']),
    /**
     * Returns the progress percentage
     *
     * @returns {number}
     */
    progressPercentage() {
      const percentage = (this.reportsMonitored / this.limit) * 100;
      const progressWidth = Math.min(percentage, 100);

      return `${progressWidth}%`;
    },
    /**
     * Returns copy of the number of slots remaining
     *
     * @returns {string}
     */
    slotsRemainingText() {
      const remaining = this.limit - this.reportsMonitored;
      const count = remaining < 0 ? 0 : remaining;

      return count === 1 ? '1 slot remaining' : `${count} slots remaining`;
    }
  }
};
</script>
